export default __webpack_public_path__ + "img/a84668f0fd3d9c75ab98f21408832df4.svg";